const SOCIAL_MEDIA_FORMATS = [
    { id: 'ig-feed-4-5',   label: 'Instagram Feed 4:5',          width: 1080, height: 1350 },
    { id: 'ig-feed-1-1',   label: 'Instagram Feed 1:1',          width: 1080, height: 1080 },
    { id: 'ig-story-9-16', label: 'Instagram Story / Reel 9:16', width: 1080, height: 1920 },
    { id: 'fb-feed-1-91',  label: 'Facebook Feed 1.91:1',        width: 1200, height:  630 },
    { id: 'fb-story-9-16', label: 'Facebook Story 9:16',         width: 1080, height: 1920 },
    { id: 'x-16-9',        label: 'X (Twitter) 16:9',            width: 1200, height:  675 },
    { id: 'linkedin-1-91', label: 'LinkedIn 1.91:1',             width: 1200, height:  627 },
]

export default SOCIAL_MEDIA_FORMATS
